import { create } from "zustand";

/**
 * Current session user (WS / lightweight updates). Avoids eager import of `client.js`
 * so `@/store` does not pull the full API client graph during module init (prod ordering).
 */
export const useCurrentUserStore = create((set) => ({
  user: null,
  loading: false,
  error: null,

  updateUser: (partial) => {
    set((state) => ({ user: { ...(state.user || {}), ...partial } }));
  },
}));
